import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <section
      className="ss-container"
      style={{ paddingBlock: 'var(--ss-space-8)', textAlign: 'center' }}
    >
      <h1>Page not found</h1>
      <p style={{ marginTop: 'var(--ss-space-3)' }}>
        We couldn’t find what you were looking for.
      </p>
      <p style={{ marginTop: 'var(--ss-space-5)' }}>
        <Link className="ss-btn ss-btn--primary" to="/">
          Back home
        </Link>
      </p>
    </section>
  );
}
